import {
  Box,
  CreateToastFnReturn,
  Spinner,
  Stack,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { matchPath, useLocation, useParams } from "react-router-dom";
import { useKydEvent } from "../../hooks/useKydEvent";
import EventDetailSections from "../../sections/EventDetailSections";
import { createOnUpdateEvent, EditModalType } from "../../../../utils";
import { useCallback, useMemo, useState } from "react";
import { useLoading } from "../../../hooks/form";
import { useDialog } from "../../../../Common/Dialog";

const AtteendeeNavSection = () => {
  const { event_id } = useParams();
  const location = useLocation();
  const {
    kydEvent,
    loading: isEventLoading,
    refetch,
  } = useKydEvent(event_id, {
    sectionTypes: ["attendees"],
  });
  const [modalType, setModalType] = useState(EditModalType.INACTIVE);
  const [loading, updateLoading] = useLoading({
    event: false,
  });
  const dialog = useDialog();
  const toast = useToast();

  const currentNavTabSections = useMemo(() => {
    if (!kydEvent) return [];

    const currentTab = kydEvent.nav.find((nav) =>
      matchPath(nav.url, location.pathname)
    );
    if (currentTab) {
      return currentTab.sections;
    }

    return [];
  }, [kydEvent]);

  const onUpdateEvent = useCallback(
    createOnUpdateEvent({
      dialog,
      event_id,
      refetch,
      setLoading: (isLoading) => updateLoading("event", isLoading),
      setModalType,
      toast,
    }),
    [event_id, refetch, updateLoading, dialog, toast, setModalType]
  );

  return (
    <VStack maxW="5xl" w="full">
      {!kydEvent?.nav ? (
        <VStack w="100%">
          <Spinner />
        </VStack>
      ) : null}
      <EventDetailSections
        isLoading={isEventLoading || loading.event}
        onUpdateEvent={onUpdateEvent}
        setModalType={setModalType}
        refetchEvent={refetch}
        modalType={modalType}
        sections={currentNavTabSections}
      />
    </VStack>
  );
};

export default AtteendeeNavSection;
